<template>
  <div class="row">
    <div class="form-group col-6">
      <label class="control-label" for="assistant_type">Assistant Type</label>
      <select id="assistant_type" v-model="assistantType" :disabled="disabletype" class="form-control"
              name="type">
        <option v-for="(value, key) in types" :value="key">{{ value }}</option>
      </select>
    </div>
    <div v-if="id" class="col-12 mb-4" style="height: 300px;">
      <label for="control-label">Response Format Schema</label>
      <textarea v-model="schema" name="response_format_schema" class="d-none"></textarea>
      <vue-monaco-editor
          v-model:value="schema"
          theme="vs-dark"
          language="json"
          :options="MONACO_EDITOR_OPTIONS"
      />
    </div>
    <div v-if="id && !loading" class="col-12 mt-4">
      <p><strong>Attached Vector Store</strong></p>
      <ul v-if="vectors.length > 0" class="list-group mb-4">
        <li v-for="vector in vectors" class="list-group-item">
          <button v-on:click="removeVectorStore(vector.id)" type="button" class="mr-2 btn btn-sm btn-danger"><i
              class="fa fa-trash"></i></button>
          <a :href="`https://platform.openai.com/storage/vector_stores/${vector.id}`"
             target="_blank">{{ vector.name }}</a>
        </li>
      </ul>
      <p v-else class="alert alert-info">No vector stores attached</p>
      <div class="form-group">
        <select id="vector-store"
                class="form-control mb-4" name="vector-store"
                style="width: 100%;"></select>
      </div>
      <button class="btn btn-default" type="button" v-on:click="this.attachVector">Attach Vector Store</button>
    </div>
  </div>
</template>

<script>

import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'

const FilePond = vueFilePond(FilePondPluginFileValidateType)
const MONACO_EDITOR_OPTIONS = {
  automaticLayout: true,
  formatOnType: true,
  formatOnPaste: true,
}
export default {
  props: ['id', 'vectorsp', 'schemap', 'available_vectorsp', 'typep', 'types', 'disabletype', 'documentretrievalEnabled'],
  components: {
    FilePond
  },
  data() {
    return {
      assistantType: this.typep || 'feedback',
      enableDocumentRetrieval: this.documentretrievalEnabled || false,
      vectors: this.vectorsp || [],
      selectedVector: null,
      loading: true,
      schema: this.schemap,
      MONACO_EDITOR_OPTIONS: {
        automaticLayout: true,
        formatOnType: true,
        formatOnPaste: true,
      }
    }
  },
  methods: {
    change(checked, meter) {
      if (!checked) {
        let num = parseInt(meter.split('-')[1])
        // remove all meters after the meter that was unchecked
        this.meters = this.meters.filter(m => {
          let mNum = parseInt(m.split('-')[1])
          return mNum < num
        })
      }
    },
    removeVectorStore: async function (vectorId) {
      console.log(vectorId)
      this.vectors = []
      let resp = await fetch(`/assistants/${this.id}/vector-store/clear`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({vectors: this.vectors})
      })
      let data = await resp.json()
      console.log(data)
    },
    attachVector: async function () {
      if (this.selectedVector && !this.vectors.some(item => item.id === this.selectedVector.id)) {
        // just replace vectors with the selected vector since
        // OpenAI will only allow a single vector to be attached
        this.vectors = [this.selectedVector]
        let resp = await fetch(`/assistants/${this.id}/vector-store/attach`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
          },
          body: JSON.stringify({vectors: this.vectors})
        })
        let data = await resp.json()
        console.log(data)
      }
    },
    initVectorSelect: async function () {
      let self = this;
      $(() => {
        const $selectEl = $(`#vector-store`)
        let data = [];
        for (let key in this.available_vectorsp) {
          data.push({id: key, text: this.available_vectorsp[key]})
        }
        $selectEl.select2({
          ajax: {
            url: '/vector-stores',
            dataType: 'json',
            data: function (params) {
              return {
                search: params.term
              }
            },
            processResults: function (data) {
              return {
                results: data.data.map((item) => {
                  return {id: item.vector_id, text: `${item.name} - (${item.id})`}
                })
              }
            }
          }
        }).on('change', function () {
          let selected = $(this).select2('data')
          self.selected = selected[0]
          self.selectedVector = {id: selected[0].id, name: selected[0].text}
        })
      })
      this.loading = false
    },
  },
  mounted() {
    this.initVectorSelect()
  }
}
</script>
